import { useEffect } from 'react'
// key - the name of the key to respond to, compared against event.key
// action - the action to perform on key press
export default function useKeyPress (key:string, action: () => void) {
  useEffect(() => {
    function onKeyDown (e: KeyboardEvent) {
      if (e.key === key) action()
    }
    document.addEventListener('keydown', onKeyDown, { capture: true }) // NOTE - might want to use {once: true} if it doesn't cause react race-conditions
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [action, key])
}
